import { action, makeAutoObservable, runInAction } from 'mobx';

import { HelperCore, HelpOther } from '@/common/helper';
import { request } from '@/common';
import Loader from '@/common/helper/loader';
import globalStore from '@/store/global';
import CreateMcpModal from '@/components/modal/create-wcp';
import { INVITE_STATUS_ACTIVE } from '@/components/modal/invite-form/constant';
import client from '@/store/client';
import UpgradeModal from '@/components/modal/upgrade';
import userStore from '@/store/user';
import { getAgentFlowId, McpAgentType } from '@shared/constants/mcp';

class Store {
  taIndex = 0;
  inputVal = '';
  showMyAgent = false;
  showPlayground = false;
  isSmallWindow = false;
  foldMenu = false;
  showTopTab = false;
  isFocus = false;
  searched = false;
  recorded = false;
  canBlur = true;
  searchList = [];
  recordList = [];
  agentList = [];
  workFlowList = []
  exampleData = [];
  myAgentList = [];
  loadedMine = false;
  superAgentId = '9113bbe12b834c298ab65f7e54edbfd0'; // 深度研究智能体 id
  inviteBtnStore = null;
  chatLimit = {
    // daily_max : 20,
    // daily_left : 10,
    // invite_total : 20,
    // invite_left : 1,
  }

  get showRecordList() {
    return this.isFocus && !this.inputVal.trim();
  }
  get showSearchList() {
    console.log('showSearchList', this.isFocus, this.inputVal.trim());
    return this.isFocus && this.inputVal.trim();
  }
  constructor() {
    makeAutoObservable(this);

    if(!HelperCore.IS_PROD){
      window._agentPageStore = this;
    }
  }

  lockMomentCanBlur = () => {
    runInAction(() => {
      this.canBlur = false;
      setTimeout(() => {
        this.canBlur = true;
      }, 100);
    });
  };
  setIsFocus = flag => {
    if (!this.canBlur && !flag) return;
    runInAction(() => {
      this.isFocus = flag;
    });
  };

  setInputVal = val => {
    runInAction(() => {
      this.inputVal = val;
    });
  };

  getRecordList = () => {
    this.recorded = false;
    request
      .get('/ai_agent/recent', { params: { limit: 10 } })
      .then(res => {
        const list = res.data?.list || [];
        runInAction(() => {
          this.recordList = list;
        });
      })
      .finally(() => {
        runInAction(() => {
          this.recorded = true;
        });
      });
  };

  delRecord = (id, fnCb) => {
    request.post('/ai_agent/recent/del', { id }).then(res => {
      if (res.code == 0) {
        runInAction(() => {
          this.recordList = this.recordList.filter(item => item.id != id);
          fnCb && fnCb();
        });
      }
    });
  };

  getSearchList = () => {
    if (!this.inputVal.trim()) return;
    this.searched = false;
    request
      .get('/ai_agent/search', {
        params: {
          wd: this.inputVal,
        },
      })
      .then(res => {
        runInAction(() => {
          this.searchList = res.data?.list || [];
        });
      })
      //.catch(Loader.error)
      .finally(() => {
        runInAction(() => {
          this.searched = true;
        });
      });
  };

  getAgents = withdExample => {
    request
      .get('/ai_agent/index')
      .then(res => {
        const list = res.data?.list || [];
        this.getWorkFlowAgents(list, withdExample)
        
      })
      .catch(res => {
        //未在白名单时报403
        globalStore.gotoHome(true);
      })
      .finally(() => {});
  };
  getWorkFlowAgents = (agentList, withdExample) => {
    
    request
      .post('/ai_agent_flow/list', {
        page: 1,
        page_size: 100, // 最大 50
      })
      .then(res => {
        const list = res.data?.flow_list || [];
        console.log("agentList is", agentList)
        runInAction(() => {
          if (withdExample) {
            const exampleData = {
              category: 'example',
              title: '实操案例',
              list: [],
            };
            this.agentList = [exampleData, ...list];
            
          } else {
            this.agentList = list;
          }
          if (list && list.length) {
            this.agentList = [...agentList, {
              category: 'workflow_agent',
              intro: "工作流详细",
              title: "工作流",
              list: list.map((item) => ({
                id: getAgentFlowId(item),
                title: item.flow_title,
                greeting: item.flow_desc,
                icon: item.flow_images,
                creator: '纳米AI',
                agent_type: 9 // 暂定
              }))
            }]
          } else {
             this.agentList = [...agentList]
          }
          
        });
      })
      .catch(res => {
        //未在白名单时报403
        this.workFlowList = []
      })
      .finally(() => {});
  }
  getMyAgent = fnCb => {
    request
      .get('/ai_agent/my')
      .then(res => {
        fnCb && fnCb(res);
        runInAction(() => {
          this.myAgentList = res.data?.list || [];
        });
      })
      //.catch(Loader.error)
      .finally(() => {
        runInAction(() => {
          this.loadedMine = true;
        });
      });
  };
  deleteAgent = (id, agent_type, deleteCallback) => {
    request
      .post('/ai_agent/delete', { id, agent_type })
      .then(res => {
        if (res.code == 0) {
          runInAction(() => {
            this.myAgentList = this.myAgentList.filter(item => item.id != id);
          });
          deleteCallback && deleteCallback();
        }
      })
      .catch(Loader.error);
  };
  deleteFlowAgent = (agentInfo, deleteCallback) => {
    const { id, team_id } = agentInfo;
    
    request.post('/ai_agent_flow/delete', { flow_id : id, team_id })
    .then(res => {
      if (res.code == 0) {
        runInAction(() => {
          this.myAgentList = this.myAgentList.filter(item => item.id != id);
        });
        deleteCallback && deleteCallback();
      }
    })
    .catch(res => {
      const { data, msg } = res;
      HelpOther.toast(data?.message || msg, "error");
    });
  };
  setShowMyAgent = flag => {
    runInAction(() => {
      this.showMyAgent = flag;
    });
  };
  setIsSmallWindow = flag => {
    runInAction(() => {
      this.isSmallWindow = flag;
    });
  };
  setShowPlayGround = flag => {
    runInAction(() => {
      this.showPlayground = flag;
    });
  };

  toggleFoldMenu = () => {
    runInAction(() => {
      this.foldMenu = !this.foldMenu;
    });
  };

  toggleTopTab = flag => {
    runInAction(() => {
      this.showTopTab = flag;
    });
  };

  switchTab = index => {
    runInAction(() => {
      this.taIndex = index;
    });
  };
  gotoAgentChat = agentId => {
    userStore.doWhenLogin(() => {
      globalStore.navigate(`/tools/aiagent/chat/${agentId}`);
    });
  };
  gotoCreate = () => {
    // todo 创建智能体弹窗
    // 同步接口
    globalStore.navigate(`/tools/aiagent/manage`);
  };

  doWhenHasInvited (fn) {
    if (HelperCore.IS_LOCAL) {
      fn();
      return;
    }
    if(globalStore.inviteCodeStatus == INVITE_STATUS_ACTIVE){
      if(!client.isLLQ){
        UpgradeModal.show({
          title: '请去 纳米AI PC端，体验最新智能体功能：',
          desc: '1. 接入超多MCP工具\n2. 智能体自主规划完成任务',
          btnText: '立即下载',
        });
      } else {
        fn();
      }
    } else if (this.inviteBtnStore) {
      this.inviteBtnStore.handleUseAgent({ callback: fn });
    }
  }

  updateChatLimit = () => {
    request.get("/invitation/stats", {
      params : {

      }
    })
    .then(res => {
      const { data } = res;
      const { stats } = data;
      runInAction(() => {
        this.chatLimit = stats;
      });
    });
  }
}

const agentPageStore = new Store();

export default agentPageStore;
